/*
 * @Descripttion: 开票申请列表
 * @Author: renbh
 * @Date: 2023-02-02 09:45:55
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-08 08:49:37
 */
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import RadioTabs from '../../components/RadioTabs'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useInvoiceApplicationHook, { jumpApplicationDetail } from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../components/ButtonBar'
import DetailIcon from '../../assets/img/detail.png'
import DownloadIcon from '../../assets/img/download.png'
import { formatTime, invoicingState, invoicingType } from '../../tools/util'
import Tippy from '@tippyjs/react'

const InvoiceApplication = () => {
  const {
    hookstate,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    onDownload,
  } = useInvoiceApplicationHook()
  const {
    checkedRadioKey,
    currentRadioDict,
    dataSource,
    isTableLoading,
    pagination,
  } = hookstate

  const listColumn = [
    {
      key: 'invoiceApplicationNumber',
      title: '开票申请单号',
      align: 'left',
      width: 80,
    },
    {
      key: 'platform',
      title: '订单平台',
      align: 'left',
      width: 60,
    },
    {
      key: 'price',
      title: '下单金额',
      align: 'left',
      width: 60,
      titleRender: (
        <div>
          <span>下单金额</span>
          <Tippy
            content={
              <div className={'tooltip-card'}>
                此为咸亨给您的下单金额，并非客户的下单金额，也并非实际开票金额
              </div>
            }
          >
            <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
          </Tippy>
        </div>
      ),
    },
    {
      key: 'type',
      title: '发票类型',
      align: 'left',
      render: (text: any) =>
        invoicingType.find((item) => item.mapKey === text)?.name,
      width: 60,
    },
    {
      key: 'title',
      title: '发票抬头',
      align: 'left',
    },
    {
      key: 'enterPriseName',
      title: '申请人',
      align: 'left',
    },
    {
      key: 'applicationTime',
      title: '申请时间',
      align: 'left',
      render: (text: any) => formatTime(text),
      width: 100,
    },
    {
      key: 'invoiceNum',
      title: '发票号码',
      align: 'left',
      render: (text: any) => <span>{text || '-'}</span>,
      width: 100,
    },
    {
      key: 'invoicingState',
      title: '开票状态',
      align: 'left',
      render: (text: any) =>
        invoicingState.find((item) => item.value === text)?.name,
      width: 60,
    },
    {
      key: 'operate',
      title: '操作',
      render: (text: any, record: any) => (
        <div className={style['operate-tools']}>
          <Tooltip title="详情" getPopupContainer={() => document.body}>
            <img
              src={DetailIcon}
              alt=""
              className={style['tool']}
              onClick={() => jumpApplicationDetail(record)}
            />
          </Tooltip>
          {record.invoicingState === '1' && (
            <Tooltip title="下载发票" getPopupContainer={() => document.body}>
              <img
                src={DownloadIcon}
                alt=""
                className={style['tool']}
                onClick={() => onDownload(record)}
              />
            </Tooltip>
          )}
        </div>
      ),
      align: 'left',
      width: 50,
    },
  ]

  return (
    <div style={{ padding: '24px' }}>
      <Search
        fieldsData={[
          'invoiceApplicationNum',
          'invoiceNum',
          'platform',
          'price',
          'invoiceType',
          'title',
          'enterPriseName',
          'createTimeBegin',
          'createTimeEnd',
        ]}
        onSearch={handleSearchClick}
        keyName="INVOICEAPPLICATION"
        ScreenKey="INVOICEAPPLICATION"
      />
      <div className={style['inner-content']}>
        <div className={style['tab-container']}>
          <RadioTabs
            defaultKey={checkedRadioKey}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        <TableAntd
          dataSource={dataSource}
          listColumn={listColumn}
          loading={isTableLoading}
          Y={360}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
        ></TableAntd>
      </div>
    </div>
  )
}
export default InvoiceApplication
/*
 * @Descripttion: 开票申请列表
 * @Author: renbh
 * @Date: 2023-02-02 09:45:55
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-08 08:49:37
 */
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import RadioTabs from '../../components/RadioTabs'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useInvoiceApplicationHook, { jumpApplicationDetail } from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../components/ButtonBar'
import DetailIcon from '../../assets/img/detail.png'
import DownloadIcon from '../../assets/img/download.png'
import { formatTime, invoicingState, invoicingType } from '../../tools/util'
import Tippy from '@tippyjs/react'

const InvoiceApplication = () => {
  const {
    hookstate,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    onDownload,
  } = useInvoiceApplicationHook()
  const {
    checkedRadioKey,
    currentRadioDict,
    dataSource,
    isTableLoading,
    pagination,
  } = hookstate

  const listColumn = [
    {
      key: 'invoiceApplicationNumber',
      title: '开票申请单号',
      align: 'left',
      width: 80,
    },
    {
      key: 'platform',
      title: '订单平台',
      align: 'left',
      width: 60,
    },
    {
      key: 'price',
      title: '下单金额',
      align: 'left',
      width: 60,
      titleRender: (
        <div>
          <span>下单金额</span>
          <Tippy
            content={
              <div className={'tooltip-card'}>
                此为咸亨给您的下单金额，并非客户的下单金额，也并非实际开票金额
              </div>
            }
          >
            <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
          </Tippy>
        </div>
      ),
    },
    {
      key: 'type',
      title: '发票类型',
      align: 'left',
      render: (text: any) =>
        invoicingType.find((item) => item.mapKey === text)?.name,
      width: 60,
    },
    {
      key: 'title',
      title: '发票抬头',
      align: 'left',
    },
    {
      key: 'enterPriseName',
      title: '申请人',
      align: 'left',
    },
    {
      key: 'applicationTime',
      title: '申请时间',
      align: 'left',
      render: (text: any) => formatTime(text),
      width: 100,
    },
    {
      key: 'invoiceNum',
      title: '发票号码',
      align: 'left',
      render: (text: any) => <span>{text || '-'}</span>,
      width: 100,
    },
    {
      key: 'invoicingState',
      title: '开票状态',
      align: 'left',
      render: (text: any) =>
        invoicingState.find((item) => item.value === text)?.name,
      width: 60,
    },
    {
      key: 'operate',
      title: '操作',
      render: (text: any, record: any) => (
        <div className={style['operate-tools']}>
          <Tooltip title="详情" getPopupContainer={() => document.body}>
            <img
              src={DetailIcon}
              alt=""
              className={style['tool']}
              onClick={() => jumpApplicationDetail(record)}
            />
          </Tooltip>
          {record.invoicingState === '1' && (
            <Tooltip title="下载发票" getPopupContainer={() => document.body}>
              <img
                src={DownloadIcon}
                alt=""
                className={style['tool']}
                onClick={() => onDownload(record)}
              />
            </Tooltip>
          )}
        </div>
      ),
      align: 'left',
      width: 50,
    },
  ]

  return (
    <div style={{ padding: '24px' }}>
      <Search
        fieldsData={[
          'invoiceApplicationNum',
          'invoiceNum',
          'platform',
          'price',
          'invoiceType',
          'title',
          'enterPriseName',
          'createTimeBegin',
          'createTimeEnd',
        ]}
        onSearch={handleSearchClick}
        keyName="INVOICEAPPLICATION"
        ScreenKey="INVOICEAPPLICATION"
      />
      <div className={style['inner-content']}>
        <div className={style['tab-container']}>
          <RadioTabs
            defaultKey={checkedRadioKey}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        <TableAntd
          dataSource={dataSource}
          listColumn={listColumn}
          loading={isTableLoading}
          Y={360}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
        ></TableAntd>
      </div>
    </div>
  )
}
export default InvoiceApplication
